<template>
  <div class="cap-tooltip" :style="{ left: x + 'px', top: y + 'px' }">
    <div class="tt-title">{{ content.title }}</div>
    <div class="tt-row">
      <span class="tt-lbl">Capacity</span
      ><span>{{ content.capacity.toFixed(2) }} hrs</span>
    </div>
    <div class="tt-row">
      <span class="tt-lbl">Demand</span><span>{{ content.demand.toFixed(2) }} hrs</span>
    </div>
    <div class="tt-row">
      <span class="tt-lbl">Utilisation</span
      ><span :style="{ color: pctColour }">{{ content.pct }}%</span>
    </div>
    <div class="tt-row" v-if="content.overBy !== null">
      <span class="tt-lbl">Over by</span
      ><span style="color: #dc2626">{{ content.overBy.toFixed(2) }} hrs</span>
    </div>
    <div class="tt-row" v-if="content.remaining !== null">
      <span class="tt-lbl">Remaining</span
      ><span style="color: #16a34a">{{ content.remaining.toFixed(2) }} hrs</span>
    </div>
    <div class="tt-bar-wrap">
      <div
        :style="{
          height: '100%',
          width: Math.min(content.pct, 100) + '%',
          background: pctColour,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CapacityTooltip",
  props: {
    content: { type: Object, required: true },
    x: { type: Number, required: true },
    y: { type: Number, required: true },
  },
  computed: {
    pctColour() {
      if (this.content.pct >= 100) return "#dc2626";
      if (this.content.pct >= 80) return "#d97706";
      return "#16a34a";
    },
  },
};
</script>

<style scoped lang="scss">
.cap-tooltip {
  position: fixed;
  z-index: 9999;
  background: #1f2937;
  color: #fff;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 11px;
  font-family: "Roboto", sans-serif;
  pointer-events: none;
  min-width: 200px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);

  .tt-title {
    font-size: 12px;
    font-weight: 600;
    border-bottom: 1px solid #374151;
    padding-bottom: 5px;
    margin-bottom: 6px;
  }
  .tt-row {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 3px;
  }
  .tt-lbl {
    color: #9ca3af;
  }
  .tt-row span:last-child {
    font-weight: 500;
  }
  .tt-bar-wrap {
    height: 3px;
    background: #374151;
    margin-top: 7px;
  }
}
</style>
